import axios from "axios";
import { Message } from "element-ui";
// import store from "@/store";
// import { getToken } from "@/utils/auth";
// import errorCode from "@/utils/errorCode";

// axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// axios.defaults.headers["token"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'https://sdcwm1.bjyzyp.com',
  baseURL: process.env.NODE_ENV === "development" ? '/api' : 'https://wrcwmapi.dzxwbj.com',
  // headers:{
  //   'token': localStorage.getItem('token'),
  //   'Authorization': 'Bearer' + localStorage.getItem('token'), // 添加token到头部
  //   'Content-Type': 'application/json'
  // }
});
// request拦截器
service.interceptors.request.use(

  (config) => {
    config.params = config.params || {};
    config.params.token = localStorage.getItem('token')
    // 是否需要设置 token
    // const isToken = (config.headers || {}).isToken === false;
    // if (getToken() && !isToken) {
    //   config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // get请求映射params参数
    console.log(config.data, 'config.paramsconfig.params')
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              const params = propName + "[" + key + "]";
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    // const code = res.data.code || 200;
    // 获取错误信息
    // const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // if (code === 401) {
    // // Message({
    // //     message: msg,
    // //     type: "error",
    // //   });
    //   // return Promise.reject(msg);
    // } else if (code === 500) {
    //   // Message({
    //   //   message: msg,
    //   //   type: "error",
    //   // });
    //   // return Promise.reject(msg);
    // } else if (code !== 200) {
    //   // Notification.error({
    //   //   title: msg,
    //   // });
    //   // return Promise.reject(res.data);
    // } else {
    // }
    // console.log('res.code', res)
    if (res.data.code == 101) {
      localStorage.setItem('login', '1')
      // Message({
      //   message:res.message,
      //   type: 'error'
      // })
      return Promise.reject(res.data);
    } else if (res.data.code == 500) {
      localStorage.setItem('login', '2')
      Message({
        message: res.message,
        type: 'error'
      })
      return Promise.reject(res.data);
    } else {
      localStorage.setItem('login', '2')
      return res.data;
    }

  },
  (error) => {
    console.log("err" + error);
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);





export default service;
